import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewCardHeaderDropdownMenuItem: FunctionComponent<Props> = ({
    className = '',
    onClick,
    testId = TEST_ID,
    text
}) => (
    <DropdownMenuItemContainer
        className={`${className} ${styles.dropdownMenuItemContainer}`}
        onClick={onClick}
        testId={testId}>
        <DropdownText text={text} />
    </DropdownMenuItemContainer>
);

export default DetailsViewCardHeaderDropdownMenuItem;
